import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitleCasePipe } from './pipe/title-case.pipe';
import { EqualValidator } from "app/directive/equal-validator.directive";
import { ProgressDirective } from './directive/progress.directive';
import { AdminHeaderComponent } from "app/admin-header/admin-header.component";
import { AdminFooterComponent } from "app/admin-footer/admin-footer.component";
import { GaleriStandardTemplateComponent } from "app/galeri-standard-template/galeri-standard-template.component";
import { AdminStandardTemplateComponent } from "app/admin-standard-template/admin-standard-template.component";
import { HeaderComponent } from "app/header/header.component";
import { FooterComponent } from "app/footer/footer.component";
import { ProgressbarComponent } from "app/progressbar/progressbar.component";
import { BarComponent } from "app/bar/bar.component";
import { MyDatePickerModule } from "mydatepicker";
import { TimepickerModule, CarouselModule, DatepickerModule, AlertModule } from "ngx-bootstrap";
import { MomentTimezoneModule } from 'angular-moment-timezone';
import { MomentModule } from 'angular2-moment';
import { ImageUploadModule } from "app/ng2-image-upload/image-upload.module";
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { AngularFontAwesomeModule } from 'angular-font-awesome/angular-font-awesome';
import { PrettyJsonModule } from 'angular2-prettyjson';


@NgModule({
    declarations: [
        TitleCasePipe,
        EqualValidator,
        ProgressDirective,
        AdminHeaderComponent,
        AdminFooterComponent,
        GaleriStandardTemplateComponent,
        AdminStandardTemplateComponent,
        HeaderComponent,
        FooterComponent,
        ProgressbarComponent,
        BarComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        MomentTimezoneModule,
        MomentModule,
        MyDatePickerModule,
        TimepickerModule.forRoot(),
        CarouselModule.forRoot(),
        ImageUploadModule.forRoot(),
        DatepickerModule.forRoot(),
        AlertModule.forRoot(),
        MultiselectDropdownModule,
        AngularFontAwesomeModule,
        PrettyJsonModule,
    ],
    exports: [
        CommonModule,
        TitleCasePipe,
        EqualValidator,
        ProgressDirective,
        AdminHeaderComponent,
        AdminFooterComponent,
        GaleriStandardTemplateComponent,
        AdminStandardTemplateComponent,
        HeaderComponent,
        FooterComponent,
        ProgressbarComponent,
        BarComponent,
        MomentTimezoneModule,
        MomentModule,
        MyDatePickerModule,
        TimepickerModule,
        CarouselModule,
        ImageUploadModule,
        MultiselectDropdownModule,
        DatepickerModule,
        AlertModule,
        AngularFontAwesomeModule,
        PrettyJsonModule,
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/shared.module.ts